<template>
  <div>
    <appHeader></appHeader>
    <div class="container-fluid admin-send-email-to-user">
      <div class="row">
        <div class="col-md-3 col-sm-12 pr-0 dark-bg">
          <appAdminSidebar></appAdminSidebar>
        </div>
        <transition appear name="fade">
          <div class="col-md-9 p-4" :class="Spinner ? 'faded' : ''">
            <div style="margin: auto;" class="text-center border rounded mb-3 col-6" v-show="MessageSentTo">
              <p class="mt-2"><b>Message Sent to:</b></p>
              <p v-for="email in MessageSentTo" :key="email">
                {{ email }}
              </p>
            </div>

            <h4>Broadcast Email To All Users</h4>
            <hr />
            <b-form @submit.prevent="sendEmail">
              <div class="row">
                <div class="col-sm-6 col-md-6">
                  <label>List Users From</label>
                  <b-form-select v-model="Users" multiple :select-size="4">
                    <option v-for="client in getAuthorizedClients" :value="+client.clientId" :key="client.clientId">{{
                      client.clientName
                    }}</option></b-form-select
                  >
                  <label class="mt-3">Subject</label>
                  <b-form-input v-model="Subject"></b-form-input>
                </div>
                <div class="col-sm-6 col-md-6">
                  <div class="row">
                    <div class="col-sm-4 col-md-4">
                      <label>With User Code</label>
                      <b-form-select v-model="UserCode" :class="Loading ? 'disabled' : ''" :disabled="Loading">
                        <option v-if="Loading" value="#">Loading...</option>
                        <option value="">All</option>
                        <option v-for="code in UserCodeOptions" :key="code" :value="code">{{ code }}</option>
                      </b-form-select>
                    </div>
                    <div class="col-sm-8 col-md-8">
                      <label>Sent To</label>
                      <b-form-select v-model="SentTo" :class="Loading ? 'disabled' : ''" :disabled="Loading">
                        <option v-if="Loading" value="#">Loading...</option>
                        <option value="everyone">Everyone</option>
                        <option v-for="SentTo in SentToOptions" :key="SentTo.id" :value="+SentTo.id">{{ SentTo.name }}</option>
                      </b-form-select>
                    </div>
                  </div>
                  <label class="mt-3">Message</label>
                  <b-form-textarea
                    id="textarea"
                    v-model="Message"
                    placeholder="Enter Your Message Here…Use Basic HTML Tags for Formatting (i.e. <br> to insert a single like break)."
                    rows="4"
                    max-rows="6"
                  ></b-form-textarea>
                </div>
                <button style="width: 15%; margin: auto;" class="btn btn-primary mt-3">
                  Send Email
                </button>
              </div>
            </b-form>
            <div v-if="Spinner === true">
              <div class="centered-spinner">
                <a-spin />
              </div>
            </div>
          </div>
        </transition>
      </div>
    </div>
    <appFooter></appFooter>
  </div>
</template>

<script>
import Header from '@/components/Header.vue';
import Footer from '@/components/Footer.vue';
import AdminSidebar from '@/views/admin/AdminSidebar.vue';
import { mapState } from 'vuex';

export default {
  name: 'SendEmailToUsers',

  props: {
    activeMenuItem: String,
    activeMenu: String,
  },

  components: {
    appHeader: Header,
    appFooter: Footer,
    appAdminSidebar: AdminSidebar,
  },

  data() {
    return {
      Users: [],
      UserCode: '',
      UserCodeOptions: [],
      SentTo: 'everyone',
      SentToOptions: [],
      Subject: '',
      Message: '',
      MessageSentTo: null,
      Loading: false,
      Spinner: false,
    };
  },

  watch: {
    Users(newVal) {
      if (newVal.length > 0) {
        this.Loading = true;
        this.SentTo = '#';
        this.UserCode = '#';
        this.UserCodeOptions = [];
        this.SentToOptions = [];

        this.$store
          .dispatch('sendEmail/fetchUsersByClients', {
            client_Ids: this.Users,
            code: '',
            lockStatusType: 2,
            pageNumber: 1,
            pageSize: 5000,
            sortField: '',
            sortOrder: '',
          })
          .then(() => {
            this.populateUserCodeOptions();
            this.populateSentToOptions();
            this.Loading = false;
            this.UserCode = '';
            this.SentTo = 'everyone';
          });
      }
    },
    UserCode() {
      this.Loading = true;
      this.SentTo = '#';

      this.SentToOptions = [];
      this.$store
        .dispatch('sendEmail/fetchUsersByClients', {
          client_Ids: this.Users,
          code: this.UserCode,
          lockStatusType: 2,
          pageNumber: 1,
          pageSize: 5000,
          sortField: '',
          sortOrder: '',
        })
        .then(() => {
          this.populateSentToOptions();
          this.Loading = false;
          this.SentTo = 'everyone';
        });
    },
  },

  computed: {
    getAuthorizedClients() {
      return this.$store.getters['clientBlogs/getAuthorizedClients'];
    },
    getUsersByClientsData() {
      return this.$store.getters['sendEmail/getUsersByClientsData'];
    },
  },

  methods: {
    setActiveMenuItem: function() {
      this.$store.dispatch('adminSidebar/setActive', {
        activeMenuItem: this.activeMenuItem ? this.activeMenuItem : 'usersSendEmailToUsers',
        activeMenu: this.activeMenu ? this.activeMenu : 'users',
      });
      // console.log(this.activeMenuItem);
    },

    populateUserCodeOptions() {
      let UserCodeOptions = [];

      let Results = this.getUsersByClientsData;

      if (Results) {
        for (let i = 0; i < Results.length; i++) {
          let user = Results[i];
          let userCode = user.code;
          if (UserCodeOptions.includes(userCode) === false && userCode !== '' && userCode !== null) {
            UserCodeOptions.push(userCode);
          }
        }
      }
      this.UserCodeOptions = UserCodeOptions;
    },

    populateSentToOptions() {
      let SentToOptions = [];

      let Results = this.getUsersByClientsData;

      if (Results) {
        for (let i = 0; i < Results.length; i++) {
          let user = Results[i];
          let id = user.id;
          let name = user.lastName + ',' + user.firstName;

          if (name !== '') {
            SentToOptions.push({
              id: id,
              name: name + (user.email ? '' : ' (No Email)'),
            });
          }
        }
      }
      this.SentToOptions = SentToOptions;
    },

    sendEmail() {
      if (this.Subject === '' || this.Message === '') {
        alert('Please fill all the fields.');
        return;
      }

      const payload = {
        user_ids: this.SentTo,
        subject: this.Subject,
        message: this.Message,
      };

      if (this.SentTo === 'everyone') {
        let sentTo = [];
        let sentToOptions = this.SentToOptions;
        for (let i = 0; i < sentToOptions.length; i++) {
          sentTo.push(sentToOptions[i].id);
        }
        payload.user_ids = sentTo;
      } else {
        let sentTo = [];
        sentTo.push(this.SentTo);
        payload.user_ids = sentTo;
      }

      console.log(payload);

      // resetting to default state
      this.Users = [];
      this.UserCode = '';
      this.SentTo = 'everyone';
      this.Subject = '';
      this.Message = '';
      this.Spinner = true;

      this.$store.dispatch('sendEmail/fetchSendEmailToUsers', payload).then((data) => {
        this.Spinner = false;
        this.MessageSentTo = data;
      });
    },
  },

  created() {
    this.setActiveMenuItem();

    this.$store.dispatch('clientBlogs/fetchAuthorizedClients');
  },
};
</script>

<style lang="scss" scoped>
.admin-send-email-to-user {
  margin: -14px 0 0 0;
  min-height: 80vh;
  .badge {
    font-size: 0.8rem;
    padding: 6px 0px;
    border-radius: $border-radius-sm;
  }
}

.align-right {
  text-align: right;
}

.bold-text {
  font-weight: bold;
}

.display-flex {
  display: flex;
}

.marginAll {
  margin: 10px;
}

.disabled {
  cursor: not-allowed !important;
}

.faded {
  opacity: 0.5;
}

.centered-spinner {
  position: fixed;
  top: 50%;
  left: 62%;
  transform: translate(-50%, -50%);
  z-index: 9999;
}
</style>
